import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CustomTypography } from 'shared/ui/CustomTypography';
import {
  controlPointsState,
  infVectorState,
  morphingMaxState,
  morphingMinState,
  zeroVectorState
} from 'features/morphing/state/stageParameterAtoms';
import { VectorForm } from './forms/VectorForm';

interface Props {
  subtitle: string;
}

export const MorphingBoxForm: React.FC<Props> = ({ subtitle }) => {
  return (
    <Accordion sx={{ backgroundColor: '#404040', color: '#333' }}>
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls="cfd-content"
        id="cfd-header"
      >
        <CustomTypography >{subtitle}</CustomTypography>
      </AccordionSummary>
      <AccordionDetails>
        <Box component="div">
          <VectorForm
            vectorState={morphingMinState}
            label={"Min[mm]"}
            maxVectorState={morphingMaxState}
          />
        </Box>
        <Box component="div">
          <VectorForm
            vectorState={morphingMaxState}
            label={"Max[mm]"}
            minVectorState={morphingMinState}
          />
        </Box>
        <Box component="div">
          <VectorForm
            vectorState={controlPointsState}
            label={"Control"}
            minVectorState={zeroVectorState}
            maxVectorState={infVectorState}
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
